module.exports = __webpack_public_path__ + "static/media/meta.5a801e64.png";